import { Slider } from "components/common/Slider/Slider";
import { ColorComponentType } from "store/features/colorPicker/types";

export interface ColorComponentContainerProps<T> {
    componentKey: T;
    type: ColorComponentType;
    value: number;
    max: number;
    handleChange: (value: number, key: T) => void;
}

export const ColorComponentContainer = <T extends string,>({
    componentKey,
    type,
    value,
    max,
    handleChange,
}: ColorComponentContainerProps<T>) => {
    value = Math.round(value);
    return (
        <>
            <div className="w-18 flex-shrink-0 capitalize">{componentKey}</div>
            <div className="">
                <Slider
                    min={0}
                    max={max}
                    value={value}
                    defaultValue={0}
                    handleChange={(value) => handleChange(value, componentKey)}
                    step={1}
                />
            </div>
            <div>
                {value}
                {type === ColorComponentType.PERCENTAGE ? "%" : ""}
                {type === ColorComponentType.DEGREE ? "\u00b0" : ""}
            </div>
        </>
    );
};
